import * as React from 'react';
import { IBannerWpProps } from './IBannerWpProps';
import * as pnp from 'sp-pnp-js';
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";
import * as strings from 'bannerWpStrings';

export interface IBannerState {
  imgs: ISPImage[];
  listId: string;
}

export interface ISPImage {
  id: string;
  src: string;
  isAtive: boolean;
  description: string;
}
export default class BannerWp extends React.Component<IBannerWpProps, IBannerState> {

  constructor(props) {
    super(props);
    this.state = {
      listId: this.props.imgListId,
      imgs: this._getImagesURLFromSP(this.props.imgListId)
    };
  }

  public render() {
    const images = this._setupImages();

    return (
      <div>
      <ImageGallery
        items={images}
        slideInterval={this.props.scrollSpeed * 5000}
        showBullets={this.props.showBulletButtons}
        showThumbnails={this.props.showThumpnails}
        defaultImage = {strings.WPDefaultURL}
      />
      </div>
    );
  }


  public componentWillReceiveProps(nextProps: IBannerWpProps) {
    if (this.state.listId !== nextProps.imgListId) {
      this.state.imgs = this._getImagesURLFromSP(nextProps.imgListId);
      this.state.listId = nextProps.imgListId;
    }
  }

  private _setupImages() {
    const items = this.state.imgs.map((item, i) => (
      {
        original: this.state.imgs[i].src,
        thumbnail: this.state.imgs[i].src,
        description: this.state.imgs[i].description
      }
    ));
    return items;
  }

  private _setDefaultImage(): ISPImage {
    return {
      id: undefined,
      src: strings.WPDefaultURL,
      isAtive: undefined,
      description: strings.WPDefaultDescription
    };
  }

  private _getImages(items: any, list: ISPImage[]) {
    for (var i = 0; i < items.length; i++) {
      debugger;
      list.push({
        id: items[i].GUID,
        src: undefined,
        isAtive: items[i].Ativo,
        description: items[i].Title
      });
    }
  }

  private _getUrls(items: any, list: ISPImage[]) {
    debugger;
    for (var i = 0; i < items.length; i++) {
      list[i].src = items[i].EncodedAbsUrl;
    }
    this.state.imgs = list;
    this.setState(this.state);
  }
  
  private _getImagesURLFromSP(listId: string): ISPImage[] {
    let imgList: ISPImage[];
    imgList = [];
    if (listId != null) {
      pnp.sp.web.lists.getById(listId).items.filter('Ativo eq 1').get().then(
        (items: any[]) => this._getImages(items, imgList))
        .then(() => {
          pnp.sp.web.lists.getById(listId).items.filter('Ativo eq 1').select('EncodedAbsUrl').get()
            .then((items: any[]) => this._getUrls(items,imgList));
        }).catch(() => {
          imgList.push(this._setDefaultImage());
        });
    } else {
      imgList.push(this._setDefaultImage());
    }
    return imgList;
  }

}
